import $P from 'plugins/kapida/platformConfigs/integrationMaps/transferOrderList';
import { objectSelector } from 'theme/utils';

class TransferOrderList {
  constructor(data) {
    const { results } = data;
    this.results = results;
  }
}

class TransferOrder {
  constructor(transferOrder) {
    const {
      id,
      destination,
      number,
      orderDatePlaced,
      orderNumber,
      packet,
      packageNumber,
      source,
      state,
      targetTransferDate,
      transferItemSet,
    } = transferOrder;
    this.id = id;
    this.destination = destination;
    this.number = number;
    this.orderDatePlaced = orderDatePlaced;
    this.orderNumber = orderNumber;
    this.packet = packet;
    this.packageNumber = packageNumber;
    this.source = source;
    this.state = state;
    this.targetTransferDate = targetTransferDate;
    this.transferItemSet = transferItemSet;
  }
}

class TransferItem {
  constructor(transferItem) {
    const { id, name, product, state } = transferItem;
    this.id = id;
    this.name = name;
    this.product = product;
    this.state = state;
  }
}

class Product {
  constructor(product) {
    const { id, name, sku } = product;
    this.id = id;
    this.name = name;
    this.sku = sku;
  }
}

const productMapper = (product) => {
  const { PRODUCT } = $P.TRANSFER_ORDER.TRANSFER_ITEM;
  return new Product({
    id: objectSelector(product, PRODUCT.ID),
    name: objectSelector(product, PRODUCT.NAME),
    sku: objectSelector(product, PRODUCT.SKU),
  });
};

const transferItemMapper = (transferItems) => {
  const { TRANSFER_ITEM } = $P.TRANSFER_ORDER;
  return transferItems.map((item) => {
    return new TransferItem({
      id: objectSelector(item, TRANSFER_ITEM.ID),
      name: objectSelector(item, TRANSFER_ITEM.NAME),
      product: productMapper(objectSelector(item, TRANSFER_ITEM.PRODUCT_PATH)),
      state: objectSelector(item, TRANSFER_ITEM.STATE),
    });
  });
};

const transferOrderMapper = (transferOrders) => {
  return transferOrders.map((item) => {
    return new TransferOrder({
      id: objectSelector(item, $P.TRANSFER_ORDER.ID),
      destination: objectSelector(item, $P.TRANSFER_ORDER.DESTINATION),
      number: objectSelector(item, $P.TRANSFER_ORDER.NUMBER),
      orderDatePlaced: objectSelector(
        item,
        $P.TRANSFER_ORDER.ORDER_DATE_PLACED
      ),
      orderNumber: objectSelector(item, $P.TRANSFER_ORDER.ORDER_NUMBER),
      packet: objectSelector(item, $P.TRANSFER_ORDER.PACKAGE),
      packageNumber: objectSelector(item, $P.TRANSFER_ORDER.PACKAGE_NUMBER),
      source: objectSelector(item, $P.TRANSFER_ORDER.SOURCE),
      state: objectSelector(item, $P.TRANSFER_ORDER.STATE),
      targetTransferDate: objectSelector(
        item,
        $P.TRANSFER_ORDER.TARGET_TRANSFER_DATE
      ),
      transferItemSet: transferItemMapper(
        objectSelector(item, $P.TRANSFER_ORDER.TRANSFER_ITEM_SET_PATH, [])
      ),
    });
  });
};

export const transferOrderListMapper = (data) => {
  return new TransferOrderList({
    results: transferOrderMapper(objectSelector(data, $P.TRANSFER_ORDERS, [])),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/transferOrderList.js